import { TemplateCategory } from "@/components/confluence/templates/template-categories-search";
import {
    Template,
    TemplateCollection
} from "@/content/templates/template.types";

/**
 * Check if the route is a valid Confluence template route
 * @param route - The route to check
 * @param suffix - The suffix of the route
 * @param data - The data to check against
 * @returns True if the route is valid, false otherwise
 * @example isValidConfluenceTemplateRoute("/software/confluence/templates/...", "...", data)
 */

type ConfluenceTemplateRouteSuffix = "templates" | "categories" | "collections";

const getRouteExtension = (path: string, baseTemplate: string) => {
    const pathExtn = path.split(baseTemplate)[1];
    return pathExtn ? pathExtn : "";
};

export const isValidConfluenceTemplateRoute = (
    route: string,
    suffix: ConfluenceTemplateRouteSuffix,
    data: TemplateCategory[] | Template[] | TemplateCollection[] | undefined
) => {
    if (!data || !route.includes(suffix)) {
        return false; // Handle 404 on client side
    }

    const extension = getRouteExtension(
        route,
        `/software/confluence/templates/` +
            (suffix === "templates" ? "" : suffix + "/")
    );

    if (extension === "") {
        if (suffix === "templates") {
            return true;
        }
        return false;
    }

    if (data && !data.find((x) => x.urlSlug === extension)) {
        return false;
    }

    return true;
};
